import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/spare`,
    name: 'SPARE_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
